class MobileDock extends HTMLElement {
  constructor() {
    super();
    this.init();
  }

  init() {

    if (window.innerWidth <= 990) {
      this.classList.remove("hidden");
    }


    window.addEventListener("resize", () => {
      if (window.innerWidth <= 990) {
        this.classList.remove("hidden");
      } else {
        this.classList.add("hidden");
      }
    });


    this.setupEventListeners();
  }

  setupEventListeners() {

    const menuButton = this.querySelector('[data-action="menu"]');
    if (menuButton) {
      menuButton.addEventListener("click", () => {
    
        document.dispatchEvent(new CustomEvent("toggle-menu-drawer"));
        this.setActiveItem(menuButton);
      });
    }


    const searchButton = this.querySelector('[data-action="search"]');
    if (searchButton) {
      searchButton.addEventListener("click", () => {
    
        document.dispatchEvent(new CustomEvent("toggle-search-modal"));
        this.setActiveItem(searchButton);
      });
    }


    const cartButton = this.querySelector('[data-action="cart"]');
    if (cartButton) {
      cartButton.addEventListener("click", () => {
    
        document.dispatchEvent(new CustomEvent("toggle-cart-drawer"));
        this.setActiveItem(cartButton);
      });
    }


    const popupButtons = this.querySelectorAll('[data-action="popup"]');
    if (popupButtons.length > 0) {
      popupButtons.forEach((button) => {
        button.addEventListener("click", () => {
          const popupId = button.getAttribute("data-popup-id");
          if (popupId) {
        
            document.dispatchEvent(
              new CustomEvent("toggle-popup", {
                detail: { popupId: popupId },
              }),
            );
          }
          this.setActiveItem(button);
        });
      });
    }


    const actionButtons = this.querySelectorAll(".nav-item[data-action]");
    actionButtons.forEach((button) => {
      button.addEventListener("click", () => {
        this.setActiveItem(button);
      });
    });
  }

  setActiveItem(activeItem) {

    const navItems = this.querySelectorAll(".nav-item");
    navItems.forEach((item) => {
      if (item !== activeItem) {
        item.classList.remove("nav-item-active");
        const navText = item.querySelector(".nav-text");
        if (navText) navText.classList.remove("nav-text-active");

    
        const activeIconImage = item.querySelector(".nav-icon-active");
        if (activeIconImage) activeIconImage.classList.add("hidden");

    
        const regularIconImage = item.querySelector(".nav-icon:not(.nav-icon-active)");
        if (regularIconImage) regularIconImage.classList.remove("hidden");

    
        const paths = item.querySelectorAll("svg path");
        paths.forEach((path) => {
          if (path.hasAttribute("stroke")) {
            path.setAttribute("stroke", "#CC986F");
          }
          if (
            path.hasAttribute("fill") &&
            path.getAttribute("fill") !== "none"
          ) {
            path.setAttribute("fill", "#CC986F");
          }
        });
      }
    });


    if (
      !activeItem.hasAttribute("href") ||
      activeItem.hasAttribute("data-action")
    ) {
      activeItem.classList.add("nav-item-active");
      const text = activeItem.querySelector(".nav-text");
      if (text) text.classList.add("nav-text-active");

  
      const activeIconImage = activeItem.querySelector(".nav-icon-active");
      if (activeIconImage) {
        activeIconImage.classList.remove("hidden");
    
        const regularIconImage = activeItem.querySelector(".nav-icon:not(.nav-icon-active)");
        if (regularIconImage) regularIconImage.classList.add("hidden");
      } else {
    
        const paths = activeItem.querySelectorAll("svg path");
        paths.forEach((path) => {
          if (path.hasAttribute("stroke")) {
            path.setAttribute("stroke", "var(--color-primary_color)");
          }
          if (path.hasAttribute("fill") && path.getAttribute("fill") !== "none") {
            path.setAttribute("fill", "var(--color-primary_color)");
          }
        });
      }
    }
  }
}

customElements.define("mobile-dock", MobileDock);

